import React from 'react'

interface Props {
  showHotspotsAmenties: boolean,
  showHotspots: boolean,
  hotspotsData: any,
  angle: number,
  handleSelectedHotspot: any
  colorsData: any,
  showTowersBtn: boolean,
  propertiesData: any,
  links: any,
  colorOnHover: any
}

interface State {
  showHotspots: boolean,
  showAnimation: boolean,
  currentRadius: number,
  wordToShow: any,
  currentWidth: any,
  currentHotspotHover: number
}

class Hotspots extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      showHotspots: false,
      showAnimation: true,
      currentRadius: 5,
      wordToShow: '',
      currentWidth: 0,
      currentHotspotHover: -1
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
      if(this.props.hotspotsData !== prevProps.hotspotsData && this.props.hotspotsData.hotspots_coord_file){
        this.setState({
          showHotspots: true
        })
      }
      if(prevProps.angle !== this.props.angle){
        this.setState({
          showAnimation: false
        }, () => {
          this.setState({
            showAnimation: true
          })
        })
        //this.handleCreateHotspots()
      }
      if(prevProps.links !== this.props.links){
        this.handleCreateHotspots();
      }
  }

  componentDidMount(): void {
    this.props.propertiesData.attributes.map((attribute: any) => {
      if(attribute.type === 'Hierarchical' && attribute.padre !== null){
        this.setState({
          wordToShow: attribute.name
        })
      }

      return 0
    })
      var decreasing = false 
      setInterval(() => {
        if(this.state.currentRadius + 1 <= 15 && decreasing === false){
          this.setState({
            currentRadius: this.state.currentRadius + 1
          }, () => {
            decreasing = this.state.currentRadius === 15
          })
        }
        if(this.state.currentRadius - 1 >= 5 && decreasing){
          this.setState({
            currentRadius: this.state.currentRadius - 1
          }, () => {
            decreasing = this.state.currentRadius === 5 ? false:true
          })
        }
      },65)
      this.setState({
        showHotspots: true
      })
  }

  handleCreateRect = (payload: any, index: number) => {

    var id = payload.id

    //console.log(id);
    
    
    var result = ''

    //if(id.includes(this.state.wordToShow.substring(0, this.state.wordToShow.length-1))){
      result = id.replace(/\d+/g, (match: any) => ` ${match} `).split(/(?=[A-Z])/).join(' ');
    //}


    var textSvg = 
    <text 
      x={payload.verts[0]} 
      y={payload.verts[1] - 40} 
      id='text'
      fill={this.props.colorsData.secondary_text}
      dominant-baseline="middle"
      text-anchor="middle"
      style={{
        opacity: this.props.showTowersBtn ? 1:0,
        transition: 'all 0.3s ease-in-out',
        fontSize: '1rem',
        zIndex: 2,
        cursor: 'pointer'
      }}
    >
      {result}
    </text> 

    var textId = document.getElementById('text') as any

    var textWidth = Math.round(textId?.getBBox().width)

    //console.log(textWidth);
    

    var rect

    if(!isNaN(textWidth) && this.state.currentWidth !== textWidth){
      this.setState({
        currentWidth: textWidth
      }, () => {
        rect = 
          <rect 
            x={payload.verts[0] - (this.state.currentWidth / 1.35)} 
            y={payload.verts[1] - 57} 
            height={'2rem'} 
            width={this.state.currentWidth  ? this.state.currentWidth  + this.state.currentWidth  / 2 : 70 } 
            fill={this.state.currentHotspotHover === index ? this.props.colorOnHover:this.props.colorsData.main_buttons}
            style={{
              minWidth: '2rem',
              opacity: this.props.showTowersBtn ? 1:0,
              transition: 'all 0.3s ease-in-out',
              zIndex: 2,
              cursor: 'pointer'
            }}
            rx="5" 
            ry="5"
          ></rect>
      })
    }
    else {
      rect = 
          <rect 
            x={payload.verts[0] - (this.state.currentWidth / 1.35)} 
            y={payload.verts[1] - 57} 
            height={'2rem'} 
            width={this.state.currentWidth  ? this.state.currentWidth  + this.state.currentWidth  / 2 : 70 } 
            fill={this.state.currentHotspotHover === index ? this.props.colorOnHover:this.props.colorsData.main_buttons}
            style={{
              minWidth: '2rem',
              opacity: this.props.showTowersBtn ? 1:0,
              transition: 'all 0.3s ease-in-out',
              zIndex: 2,
              cursor: 'pointer'
            }}
            rx="5" 
            ry="5"
          ></rect>
    }

    
    return (
      <g>
        {
          rect
        }
        {
          textSvg
        }
      </g>
    )
  }

  handleCreateHotspots = () => {
    if(this.props.hotspotsData.hotspots_coord_file && this.props.hotspotsData.hotspots_coord_file[this.props.angle]){
      if(this.props.hotspotsData.hotspots_coord_file[this.props.angle].hotspots.length > 0){
        return(
          this.props.hotspotsData.hotspots_coord_file[this.props.links.length === 50 ? this.props.angle * 2:this.props.angle].hotspots.map((hotspot: any, index: number) => 
              <g
              key={hotspot.id + index + 50}
              style={{
                pointerEvents: this.props.showHotspots ? 'visibleFill':'none',
              }}
              onClick={() => {
                this.props.handleSelectedHotspot(hotspot.id)
              }}
              onMouseEnter={() => {
                this.setState({
                  currentHotspotHover: index
                })
              }}
              onMouseLeave={() => {
                this.setState({
                  currentHotspotHover: -1
                })
              }}
              >
                <circle
                  cx={hotspot.verts[0]}
                  cy={hotspot.verts[1]}
                  r={this.state.currentRadius}
                  style={{
                    cursor: 'pointer',
                    fill:'rgba(255,255,255,0)',
                    stroke: 'rgba(255,255,255,1)',
                    fillRule: 'evenodd',
                    strokeWidth: 3.5,
                  }}
                >

                </circle>
              </g>
          )
        )
      }
    }
  }

  handleCreateBillboards = () => {
    if(this.props.hotspotsData.hotspots_coord_file && this.props.hotspotsData.hotspots_coord_file[this.props.angle]){
      if(this.props.hotspotsData.hotspots_coord_file[this.props.angle].hotspots.length > 0){
        return(
          this.props.hotspotsData.hotspots_coord_file[this.props.links.length === 50 ? this.props.angle * 2:this.props.angle].hotspots.map((hotspot: any, index: number) => 
              <g
              key={hotspot.id + index + 50}
              style={{
                cursor: 'pointer',
                pointerEvents: this.props.showHotspots ? 'visibleFill':'none',
              }}
              onClick={() => {
                this.props.handleSelectedHotspot(hotspot.id)
              }}
              onMouseEnter={() => {
                this.setState({
                  currentHotspotHover: index
                })
              }}
              onMouseLeave={() => {
                this.setState({
                  currentHotspotHover: -1
                })
              }}
              >
                {
                  this.handleCreateRect(hotspot, index)
                }
              </g>
          )
        )
      }
    }
  }

  render(): React.ReactNode {
    console.log(this.state.showHotspots);
    
      return(
        <>
        <div className={this.props.showHotspots ? 'hotspots-layout fade-in':'hotspots-layout fade-out'}>
          {
            this.state.showHotspots && this.state.showAnimation ?
            <svg
            width={'100%'}
            height={'100%'}
            preserveAspectRatio="xMidYMid slice"
            viewBox="0 0 2000 1400"
            style={{
              overflow: 'hidden',
              pointerEvents: 'none',
              position: 'absolute',
              cursor: 'pointer'
            }}
          >
            {
              this.handleCreateHotspots()
            }
          </svg>:null
          }
          {
            this.state.showHotspots && this.state.showAnimation ?
            <svg
            width={'100%'}
            height={'100%'}
            preserveAspectRatio="xMidYMid slice"
            viewBox="0 0 2000 1400"
            style={{
              overflow: 'hidden',
              pointerEvents: 'none',
              position: 'absolute',
              cursor: 'pointer'
            }}
          >
            {
              this.handleCreateBillboards()
            }
          </svg>:null
          }
        </div>
        <div className={this.props.showHotspotsAmenties ? 'hotspots-layout fade-in':'hotspots-layout fade-out'}>
        
        {
          this.state.showHotspots && this.state.showAnimation ?
          <svg
          width={'100%'}
          height={'100%'}
          preserveAspectRatio="xMidYMid slice"
          viewBox="0 0 2000 1400"
          style={{
            overflow: 'hidden',
            pointerEvents: 'none',
            position: 'absolute',
            cursor: 'pointer'
          }}
        >
          {
            this.handleCreateBillboards()
          }
        </svg>:null
        }
      </div></>
      )
  }
}

export default Hotspots